export interface AppConfig {
  readonly auth: {
    isWalletAllowed: boolean
    isSignUpByEmailAllowed: boolean
    isTwitterAllowed: boolean
    isDiscordAllowed: boolean
    isAuthRequired: boolean
    isReferralCodeFlowAllowed: boolean
  }
  readonly tokenMintAllowed: boolean
  readonly isMainNetFeature: boolean
  readonly demoUpDownAi: boolean
  /** Bullseye leaderboard block (DEV-147): boards, realtime, history, the rank row. */
  readonly bullsEyeLeaderboard: boolean
  readonly mobile: {
    upDown: boolean
    oneVsOne: boolean
    bullsEye: boolean
    setups: boolean
    rewards: boolean
  }
}

export enum Stand {
  beta = 'beta',
  dev = 'dev',
  prod = 'prod',
  mainnet = 'mainnet'
}
